import { render, staticRenderFns } from "./Basic.vue?vue&type=template&id=7e62af54&scoped=true&"
import script from "./Basic.vue?vue&type=script&lang=js&"
export * from "./Basic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e62af54",
  null
  
)

export default component.exports